import React, { useEffect, useState } from "react"
import { getStockRightFSDataSSE } from "../../../modules/quote/web"
import "./index.less"
import { quote_fs_trade_info, quote_item_fs_trade_info, quote_item_trade_info, quote_trade_info } from "../../shared/quotedata/index"
import { store } from "./store"
import { Observer } from "mobx-react-lite"
import { quotedata } from "../../shared/quotedata"
import { checkIP, getCookie, QuoteTradeRecord } from "../../shared/utils"
import { StockSubType } from "../../shared/pagetype"

export function ATimeTrade(props: { quotedata: quotedata; stocksubtype: StockSubType }) {
  const [expandFS, setExpandFS] = useState({ expand: false, iconRotate: false })
  const [tradeData, setTradeData] = useState<Array<string>>([])
  const [lastItem, setLastItem] = useState("")
  const [show_trade_number, setShowTradeNumber] = useState(7)
  const isCN = checkIP()

  const clickExpandFS = () => {
    if (!expandFS.expand) {
      setExpandFS({ expand: true, iconRotate: true })
      setShowTradeNumber(14)
    } else {
      setExpandFS({ expand: false, iconRotate: false })
      setShowTradeNumber(7)
    }
  }

  const clickMore = () => {
    location.href = `/quote/stockmore_new.html?id=${props.quotedata.code}&mk=${props.quotedata.market}&tab=2`
  }

  const isOverseas = () => {
    if (getCookie("uidal") != null && getCookie("uidal") != undefined && getCookie("uidal") != "") {
      return (props.stocksubtype == StockSubType.深市主板 || props.stocksubtype == StockSubType.创业板) && getCookie("mtp") == "2"
    } else {
      return (props.stocksubtype == StockSubType.深市主板 || props.stocksubtype == StockSubType.创业板) && getCookie("quote_lt") == "2"
    }
  }

  useEffect(() => {
    // 深市 - 判断是否为海外用户 海外手机号登录也算海外用户
    if (isOverseas()) {
      store.setQuoteTradeType(QuoteTradeRecord.一档行情)
    } else {
      store.setQuoteTradeType(QuoteTradeRecord.五档行情)
    }

    let sse = getStockRightFSDataSSE(props.quotedata.quotecode, (data: any) => {
      setLastItem(data[0])
      setTradeData(data)
    })
    return () => {
      try {
        sse.close()
      } catch (error) {}
    }
  }, [])

  return (
    <Observer>
      {() => (
        <>
          <div className={`${expandFS.expand ? "expand-fenshi" : ""}`}>
            <div className="content-hq">
              {store.StockDetail && (
                <>
                  {store.QuoteTradeType == QuoteTradeRecord.五档行情 && store.StockDetail && <FiveSellAndBuy />}
                  {store.QuoteTradeType == QuoteTradeRecord.一档行情 && store.StockDetail && <OneSellAndBuy />}
                  <ul className="tb-fenshi">
                    <li onClick={clickExpandFS}>
                      <a>
                        分时成交 <i className={`icon-trangle ${expandFS.iconRotate ? "rotate" : ""}`}></i>
                      </a>
                    </li>
                    <>
                      {tradeData.length > 0 &&
                        tradeData.map((item: any, index: number) => {
                          return (
                            index < show_trade_number && (
                              <li key={index}>
                                {quote_fs_trade_info[quote_item_fs_trade_info.时间](item).element}
                                {quote_fs_trade_info[quote_item_fs_trade_info.成交价](tradeData, lastItem, item, index, store.StockDetail).newElement}
                                {quote_fs_trade_info[quote_item_fs_trade_info.成交量](item).element}
                              </li>
                            )
                          )
                        })}
                    </>
                    <li>
                      <a
                        href="#"
                        className="more-fenshi"
                        onClick={(e) => {
                          e.preventDefault()
                          clickMore()
                        }}
                      >
                        更多成交
                      </a>
                    </li>
                  </ul>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </Observer>
  )
}

// 五档行情
function FiveSellAndBuy() {
  return (
    <>
      <ul className="tb-sell">
        <li>
          <span>卖5</span>
          {quote_trade_info[quote_item_trade_info.卖5价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖5量](store.StockDetail).element}
        </li>
        <li>
          <span>卖4</span>
          {quote_trade_info[quote_item_trade_info.卖4价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖4量](store.StockDetail).element}
        </li>
        <li>
          <span>卖3</span>
          {quote_trade_info[quote_item_trade_info.卖3价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖3量](store.StockDetail).element}
        </li>
        <li>
          <span>卖2</span>
          {quote_trade_info[quote_item_trade_info.卖2价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖2量](store.StockDetail).element}
        </li>
        <li>
          <span>卖1</span>
          {quote_trade_info[quote_item_trade_info.卖1价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖1量](store.StockDetail).element}
        </li>
      </ul>
      <ul className="tb-buy">
        <li>
          <span>买1</span>
          {quote_trade_info[quote_item_trade_info.买1价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买1量](store.StockDetail).element}
        </li>
        <li>
          <span>买2</span>
          {quote_trade_info[quote_item_trade_info.买2价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买2量](store.StockDetail).element}
        </li>
        <li>
          <span>买3</span>
          {quote_trade_info[quote_item_trade_info.买3价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买3量](store.StockDetail).element}
        </li>
        <li>
          <span>买4</span>
          {quote_trade_info[quote_item_trade_info.买4价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买4量](store.StockDetail).element}
        </li>
        <li>
          <span>买5</span>
          {quote_trade_info[quote_item_trade_info.买5价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买5量](store.StockDetail).element}
        </li>
      </ul>
    </>
  )
}

// 一档行情
function OneSellAndBuy() {
  return (
    <>
      <ul className="tb-sell">
        <li>
          <span>卖5</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖4</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖3</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖2</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖1</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖1价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖1量](store.StockDetail).element}
        </li>
      </ul>
      <ul className="tb-buy">
        <li>
          <span>买1</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买1价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买1量](store.StockDetail).element}
        </li>
        <li>
          <span>买2</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买3</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买4</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买5</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
      </ul>
    </>
  )
}
